import script from "./NotificationList.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationList.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationList.vue?vue&type=style&index=0&id=1a94b19c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./NotificationList.vue?vue&type=custom&index=0&blockType=i18n&lang=jsonc"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a94b19c"]])

export default __exports__